import { Inject, ISimpleControllerConfiguration, SimpleBaseController } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/GameModel';
import { GameLogic } from '../../Logic/GameLogic';
import { FriendsListModalController } from './FriendsList/FriendsListModalController';
import { AnimationContents } from '../../../AnimationContents';
import { ModalsNames } from '../../Common/MadalsManager/ModalsList';
import { ShopNeedleModalController } from './ShopNeedleModalController';
import { ShopLifeScreenController } from '../Screens/ShopLifeScreenController';
import { ShopScreenController } from '../Screens/ShopScreenController';
import { RootController } from '../../RootController';
import { ShopCrazyGamesModalController } from './ShopCrazyGamesModalController';
import { ConfirmationsConfirmController } from './Confirmations/ConfirmationsConfirmController';
import { ConfirmationsGetPrizeController } from './Confirmations/ConfirmationsGetPrizeController';
import { ConfirmationsYouRewardController } from './Confirmations/ConfirmationsYouRewardController';
import { ConfirmationsBuyEmbroideryController } from './Confirmations/ConfirmationsBuyEmbroideryController';
import { ConfirmationsBuyCoinsOnlyEmbroideryController } from './Confirmations/ConfirmationsBuyCoinsOnlyEmbroideryController';
import { FTUEWelcomeModalController } from "./FTUEWelcomeModalController";
import { DailyRewardModalController } from "./DailyRewardModalController";

export class ModalContainerController extends SimpleBaseController {
    $model: GameModel;
    public root: RootController;

    public constructor(
        @Inject private _options: { root: RootController },
        @Inject private _gameLogic: GameLogic,
    ) {
        super('ModalContainerController');
        this.root = _options.root;

    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        return <ISimpleControllerConfiguration>{
            childControllers: {
                shopCrazygames: {
                    controller: ShopCrazyGamesModalController,
                    model: this.$model,
                },
            },
        };
    }

    protected onInitialize() {
        this.$childControllers.get('shopCrazygames').display.visible = false;

        this._gameLogic.initModalsManager(this);

        this._gameLogic.modalsManager.preloadBitmaps(ModalsNames.friendList, AnimationContents.FRIENDS_LIST_MODAL_JSON);
        this._gameLogic.modalsManager.preloadBitmaps(ModalsNames.shopNeedle, AnimationContents.SHOP_NEEDLE_SCREEN_JSON);
        this._gameLogic.modalsManager.preloadBitmaps(ModalsNames.shopLives, AnimationContents.SHOP_LIFE_SCREEN_JSON);
        this._gameLogic.modalsManager.preloadBitmaps(ModalsNames.shopCrazyGames, AnimationContents.SHOP_CRAZY_GAMES_JSON);

        this._gameLogic.modalsManager.preloadBitmaps(ModalsNames.confirm, AnimationContents.CONFIRMATIONS_JSON);
        this._gameLogic.modalsManager.preloadBitmaps(ModalsNames.getPrize, AnimationContents.CONFIRMATIONS_JSON);
        this._gameLogic.modalsManager.preloadBitmaps(ModalsNames.youReward, AnimationContents.CONFIRMATIONS_JSON);
        this._gameLogic.modalsManager.preloadBitmaps(ModalsNames.buyEmbroidery, AnimationContents.CONFIRMATIONS_JSON);

        this._gameLogic.modalsManager.addView2Pool(ModalsNames.shopNeedle, ShopNeedleModalController, {}, this.$model);
        this._gameLogic.modalsManager.addView2Pool(ModalsNames.friendList, FriendsListModalController, { onExit: () => this._gameLogic.modalsManager.hide() }, this.$model);
        this._gameLogic.modalsManager.addView2Pool(ModalsNames.shopLives, ShopLifeScreenController, {}, this.$model.shopModel);
        this._gameLogic.modalsManager.addView2Pool(ModalsNames.shop, ShopScreenController, {}, this.$model);
        this._gameLogic.modalsManager.addView2Pool(ModalsNames.shopCrazyGames, ShopCrazyGamesModalController, {}, this.$model);

        this._gameLogic.modalsManager.addView2Pool(ModalsNames.confirm, ConfirmationsConfirmController, {
            yesClick: () => this._gameLogic.modalsManager.hide(),
            noClick: () => this._gameLogic.modalsManager.hide(),
        }, this.$model);
        this._gameLogic.modalsManager.addView2Pool(ModalsNames.getPrize, ConfirmationsGetPrizeController, { exitClick: () => this._gameLogic.modalsManager.hide() }, this.$model);
        this._gameLogic.modalsManager.addView2Pool(ModalsNames.youReward, ConfirmationsYouRewardController, { exitClick: () => this._gameLogic.modalsManager.hide() }, this.$model);
        this._gameLogic.modalsManager.addView2Pool(ModalsNames.buyEmbroidery, ConfirmationsBuyEmbroideryController, { exitClick: () => this._gameLogic.modalsManager.hide() }, this.$model);
        this._gameLogic.modalsManager.addView2Pool(ModalsNames.buyCoinsOnlyEmbroidery, ConfirmationsBuyCoinsOnlyEmbroideryController, { exitClick: () => this._gameLogic.modalsManager.hide() }, this.$model);
        this._gameLogic.modalsManager.addView2Pool(ModalsNames.ftueWelcome, FTUEWelcomeModalController, { exitClick: () => this._gameLogic.modalsManager.hide() }, this.$model);

        this._gameLogic.modalsManager.addView2Pool(ModalsNames.dailyReward, DailyRewardModalController, { exitClick: () => this._gameLogic.modalsManager.hide(), closeClick: () => this._gameLogic.modalsManager.hide() }, this.$model);
    }

    protected onResize(width: number, height: number, scale: number) {
        this._gameLogic.modalsManager.resize(width, height, scale);
    }
}
